export const ResourceTypes = {
  path: '/resource-types',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'resourceTypes',
      component: () => import('pages/resourceTypes/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.resourceTypes.name',
        path: '/resource-types',
        condition: 'resourceTypes',
      },
    },
    {
      path: 'create',
      name: 'resourceTypes-create',
      component: () => import('pages/resourceTypes/CreatePage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.create',
        parents: [
          {
            title: 'page.resourceTypes.name',
            path: '/resource-types',
            condition: 'resourceTypes',
          },
        ],
      },
    },
    {
      path: ':id',
      name: 'resourceTypes-id',
      component: () => import('src/pages/resourceTypes/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'page.resourceTypes.name',
            path: '/resource-types',
            condition: 'resourceTypes',
          },
        ],
      },
    },
    {
      path: ':id/edit',
      name: 'resourceTypes-id-edit',
      component: () => import('src/pages/resourceTypes/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.edit',
        parents: [
          {
            title: 'page.resourceTypes.name',
            path: '/resource-types',
            condition: 'resourceTypes',
          },
          {
            title: ':name',
            path: '/resource-types/:id',
          },
        ],
      },
    },
  ],
};
